import { render } from "./pedaalkracht.vue?vue&type=template&id=b2d118e8"
import script from "./pedaalkracht.vue?vue&type=script&lang=js"
export * from "./pedaalkracht.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/form-sections/pedaalkracht.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2d118e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2d118e8', __exports__)) {
    console.log('reload')
    api.reload('b2d118e8', __exports__)
  }
  
  module.hot.accept("./pedaalkracht.vue?vue&type=template&id=b2d118e8", () => {
    console.log('re-render')
    api.rerender('b2d118e8', render)
  })

}


export default __exports__